import appRoutes from './app-router.routes'

const routesCollections = {
  appRoutes,
}

export default routesCollections
